import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { BillRow, BillModalData } from '../interfaces/bill-row.interface';

export const billRowsApi = {
  /**
   * Lista de B/L-uri în format claude-design (pagina `/app/bills`).
   * @param companyId când e setat, restricționează la firma respectivă.
   */
  async get(companyId?: number, direction?: ShippingDirection): Promise<BillRow[]> {
    const params = {
      ...(typeof companyId === 'number' ? { companyId } : {}),
      ...(direction ? { direction } : {}),
    };
    const response = await http.get('/bills/rows', { params });
    return (response.data?.data as BillRow[]) ?? [];
  },

  /**
   * Detaliile complete ale unui B/L pentru modal.
   */
  async getModalData(
    id: number,
    companyId?: number,
    direction?: ShippingDirection,
  ): Promise<BillModalData> {
    const params = {
      ...(typeof companyId === 'number' ? { companyId } : {}),
      ...(direction ? { direction } : {}),
    };
    const response = await http.get(`/bills/${id}/modal`, { params });
    return response.data.data as BillModalData;
  },

  async updateClientNote(id: number, clientNote: string): Promise<string | null> {
    const response = await http.patch(`/bills/${id}/client-note`, { clientNote });
    return (response.data?.data?.clientNote ?? null) as string | null;
  },
};
